import React from 'react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { BtnAlternative } from '../buttons/Btn';

const Menu = () => {
	const [isDispalyMenu, setDisplayMenu] = useState(false);

	const handleDisplayMenu = () => {
		setDisplayMenu((prev) => !prev);
	};

	return (
		<div
			className='navbar__menu  justify-between items-center flex'
			id='mobile-menu-4'
		>
			<BtnAlternative
				text={
					<>
						<span></span>
						<span></span>
						<span></span>
					</>
				}
				className={`rounded-3xl navbar__menu--btn ${
					isDispalyMenu ? 'show-menu' : ''
				}`}
				onClick={() => handleDisplayMenu()}
			/>
			<ul
				className={`flex mt-4 flex-row md:mt-0 md:text-sm md:font-medium items-center ${
					isDispalyMenu ? 'show-menu' : ''
				}`}
			>
				<li className='p-3 mx-5 hover:bg-[#9C5FA436] rounded-16 cursor-pointer'>
					<NavLink
						key='home'
						to='/'
						style={({ isActive }) =>
							isActive ? { color: '#77498F' } : { color: '#41284E' }
						}
						className='block py-2 pr-4 pl-3 hover:bg-[rgba(156, 95, 164, 0.21)] font-bold'
					>
						صفحه اصلی
					</NavLink>
				</li>
				<li className='p-3 mx-5 hover:bg-[#9C5FA436] rounded-16 cursor-pointer'>
					<NavLink
						key='boot'
						to='/bootcamp'
						style={({ isActive }) =>
							isActive ? { color: '#77498F' } : { color: '#41284E' }
						}
						className='block py-2 pr-4 pl-3 hover:bg-[rgba(156, 95, 164, 0.21)] font-bold'
					>
						بوت‌کمپ‌ها
					</NavLink>
				</li>

				<li className='p-3 mx-5 hover:bg-[#9C5FA436] rounded-16 cursor-pointer'>
					<NavLink
						key='options'
						to='/options'
						style={({ isActive }) =>
							isActive ? { color: '#77498F' } : { color: '#41284E' }
						}
						className='block py-2 pr-4 pl-3 hover:bg-[rgba(156, 95, 164, 0.21)] font-bold'
					>
						امکانات
					</NavLink>
				</li>
				<li className='p-3 mx-5 hover:bg-[#9C5FA436] rounded-16 cursor-pointer'>
					<NavLink
						key='boot'
						to='/Price'
						style={({ isActive }) =>
							isActive ? { color: '#77498F' } : { color: '#41284E' }
						}
						className='block py-2 pr-4 pl-3 hover:bg-[rgba(156, 95, 164, 0.21)] font-bold'
					>
						تعرفه‌ها
					</NavLink>
				</li>
				<li className='p-3 mx-5 hover:bg-[#9C5FA436] rounded-16 cursor-pointer'>
					<NavLink
						key='boot'
						to='/aboutus'
						style={({ isActive }) =>
							isActive ? { color: '#77498F' } : { color: '#41284E' }
						}
						className='block py-2 pr-4 pl-3 hover:bg-[rgba(156, 95, 164, 0.21)] font-bold'
					>
						داستان ما
					</NavLink>
				</li>
			</ul>
		</div>
	);
};
export default Menu;
